var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2255_37841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3789 3.36328H22.7194V18.6258H14.3789V3.36328Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9082 10.9947C14.9082 7.89374 16.3379 5.14319 18.5355 3.36341C16.9205 2.06909 14.8817 1.28711 12.6576 1.28711C7.38835 1.28711 3.12549 5.62852 3.12549 10.9947C3.12549 16.3609 7.38835 20.7024 12.6575 20.7024C14.8816 20.7024 16.9204 19.9204 18.5355 18.626C16.3379 16.8732 14.9082 14.0958 14.9082 10.9947Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.972 10.9947C33.972 16.3609 29.7092 20.7024 24.44 20.7024C22.2159 20.7024 20.1772 19.9204 18.562 18.626C20.7861 16.8463 22.1895 14.0958 22.1895 10.9947C22.1895 7.89374 20.7596 5.14319 18.562 3.36341C20.177 2.06909 22.2159 1.28711 24.44 1.28711C29.7092 1.28711 33.9721 5.65554 33.9721 10.9947H33.972Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2255_37841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5556,
    height: 20,
    fill: "white",
    transform: "translate(0.90332 0.935547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardFooter);
export default __webpack_public_path__ + "static/media/mastercard-footer.3d1048e529776654f469e0e1801689bd.svg";
export { ForwardRef as ReactComponent };